import styled from "styled-components";

export const QuestionWrapper = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 5% auto 5% auto;
`;

export const QuestionText = styled.span`
  font: normal normal normal 40px/55px BiNeo;
  letter-spacing: 0px;
  color: #8c8c8c;
  text-align: center;
  width: 200%;

  @media screen and (max-width: 1023px) {
    font: normal normal normal 30px/55px BiNeo;
  }
`;

export const BackButtonTop = styled.div`
  padding: ${(props) => (props.top ? "30px 0 0 10%" : "0 0 10% 10%")};
  width: fit-content;
  font-size: 1.5rem;
  color: #003865;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 1024px) {
    display: ${(props) => (props.top ? "none" : "block")};
  }

  @media screen and (min-width: 1023px) {
    display: ${(props) => (props.top ? "block" : "none")};
  }

  @media screen and (max-width: 640px) {
    width: 100%;
    text-align: center;
    padding: 0 0 2rem 0;
  }
`;

export const OptionalText = styled.div`
  font-size: 1.5rem;
  margin-top: 1.5rem;
  color: #003865;
`;
